export const PLACEHOLDER_LABELS: Record<string, string> = {
  client_first_name: 'Client first name',
  client_full_name: 'Client full name',
  advisor_first_name: 'Advisor first name',
  advisor_last_name: 'Advisor last name',
  advisor_full_name: 'Advisor full name',
  advisor_message: 'Advisor message',
  event_type_name: 'Event type',
  new_event_type_name: 'New event type',
  old_event_type_name: 'Old event type',
  duration: 'Duration',
  location: 'Location',
  old_location: 'Old location',
  new_location: 'New location',
  firm_name: 'Firm name',
  booking_link: 'Booking link',
}

const PLACEHOLDER_PATTERN = /{{\s*([\w.]+)\s*}}/g
const STATEMENT_TAG_PATTERN = /{%-?[\s\S]*?-?%}/g
const ATTRIBUTE_PLACEHOLDER_PATTERN = /=("|')(?:(?!\1).)*{{\s*[\w.]+\s*}}(?:(?!\1).)*\1/g
const SCRIPT_TAG_PATTERN = /<script\b[^>]*>[\s\S]*?<\/script\s*>/gi
const EVENT_HANDLER_ATTRIBUTE_PATTERN = /\s+on[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+)/gi
const DANGEROUS_SCHEME_ATTRIBUTE_PATTERN = /([\w-]+)\s*=\s*("|')\s*(?:javascript|data):[\s\S]*?\2/gi
const HREF_ATTRIBUTE_PATTERN = /\bhref\s*=\s*(?:("|')(?:(?!\1)[\s\S])*\1|[^\s"'>]+)/gi

export interface TemplateToken {
  type: 'text' | 'chip'
  value: string
}

export const placeholderLabel = (variable: string): string => {
  const known = PLACEHOLDER_LABELS[variable]
  if (known != null) {
    return known
  }
  const humanized = variable.replace(/[_.]+/g, ' ').trim()
  return humanized.charAt(0).toUpperCase() + humanized.slice(1)
}

export const tokenizeTemplateText = (text: string): TemplateToken[] => {
  const cleaned = text.replace(STATEMENT_TAG_PATTERN, '')
  const tokens: TemplateToken[] = []
  let lastIndex = 0
  for (const match of cleaned.matchAll(PLACEHOLDER_PATTERN)) {
    const index = match.index ?? 0
    if (index > lastIndex) {
      tokens.push({ type: 'text', value: cleaned.slice(lastIndex, index) })
    }
    tokens.push({ type: 'chip', value: placeholderLabel(match[1]) })
    lastIndex = index + match[0].length
  }
  if (lastIndex < cleaned.length) {
    tokens.push({ type: 'text', value: cleaned.slice(lastIndex) })
  }
  return tokens
}

export const transformTemplateBodyHtml = (body: string, chipClassName: string): string =>
  body
    .replace(STATEMENT_TAG_PATTERN, '')
    .replace(SCRIPT_TAG_PATTERN, '')
    .replace(EVENT_HANDLER_ATTRIBUTE_PATTERN, '')
    .replace(DANGEROUS_SCHEME_ATTRIBUTE_PATTERN, (_, name: string) => `${name}="#"`)
    .replace(ATTRIBUTE_PLACEHOLDER_PATTERN, '="#"')
    .replace(HREF_ATTRIBUTE_PATTERN, 'href="#"')
    .replace(PLACEHOLDER_PATTERN, (_, variable: string) => `<span class="${chipClassName}">${placeholderLabel(variable)}</span>`)
